/**
 * =========================================================================================
 *     Copyright (c) 2026 Dobler Data Solutions, LLC. ALL RIGHTS RESERVED.
 * =========================================================================================
 *     File            :   webapp/frontend/src/utils/backupCoverage.ts
 *     Description     :   Spec 298 FR-004 (evidence/rates.md #57). The ONE reading of /api/metrics/backup/coverage the
 *                         Admin and Manager dashboards share: the backend's null (no protectable entities) is "nothing
 *                         to protect", never 0%; no answer (the call is not made when the backup tiles are not
 *                         licensed) is no figure; a measured share passes through. Sits beside slaCompliance.ts.
 *     Author          :   Claude Opus 5.5
 *     Created         :   2026-11-04
 * =========================================================================================
 */

export interface BackupCoverageReading {
  /** Protected ÷ protectable in percent; null when there is nothing to protect or no answer. */
  backupCoverage: number | null;
  /** True when the backend measured no protectable entity: the tile says "nothing to protect". */
  backupNothingToProtect: boolean;
}

export function backupCoverageFrom(res: { coveragePercent: number | null } | null): BackupCoverageReading {
  if (res === null) return { backupCoverage: null, backupNothingToProtect: false };
  return { backupCoverage: res.coveragePercent, backupNothingToProtect: res.coveragePercent === null };
}
